import { inject, Directive } from '@angular/core';

import { AppDialogRef } from './dialog-ref';
import { APP_DIALOG_DATA } from './dialog-service';

@Directive()
export abstract class DialogBase<DialogData, DialogResult> {
  protected readonly data: DialogData = inject(APP_DIALOG_DATA);

  protected readonly dialogRef: AppDialogRef<DialogBase<DialogData, DialogResult>, DialogResult> = inject(AppDialogRef);

  protected closeDialog(): void {
    this.dialogRef.cancel();
  }
}
